import { createAsyncThunk } from "@reduxjs/toolkit";
import NewsAPI from "./newsAPI";

export const fetchNewsThunk = createAsyncThunk(
  "news/fetchNews",
  async (params, thunkAPI) => {
    try {
      const data = await NewsAPI.fetchNews(params);
      return { data, key: params?.ticker ? `ticker:${params.ticker}` : `feed:${params?.sort || "recency"}` };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const fetchArticleThunk = createAsyncThunk(
  "news/fetchArticle",
  async (articleId, thunkAPI) => {
    try {
      return await NewsAPI.fetchArticle(articleId);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const fetchByTickerThunk = createAsyncThunk(
  "news/fetchByTicker",
  async ({ symbol, limit }, thunkAPI) => {
    try {
      const data = await NewsAPI.fetchByTicker(symbol, limit);
      return { symbol, data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const submitArticleThunk = createAsyncThunk(
  "news/submitArticle",
  async (payload, thunkAPI) => {
    try {
      return await NewsAPI.submitArticle(payload);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const fetchModerationQueueThunk = createAsyncThunk(
  "news/fetchModerationQueue",
  async (params, thunkAPI) => {
    try {
      return await NewsAPI.fetchModerationQueue(params);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const decideModerationThunk = createAsyncThunk(
  "news/decideModeration",
  async ({ articleId, decision, reason }, thunkAPI) => {
    try {
      return await NewsAPI.decideModeration(articleId, { decision, reason });
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);

export const fetchFollowedJournalistsThunk = createAsyncThunk(
  "news/fetchFollowedJournalists",
  async (_, thunkAPI) => {
    try {
      return await NewsAPI.fetchFollowedJournalists();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.error?.message || err.message);
    }
  }
);
